import { observable, action, computed, reaction } from 'mobx';
import lunr from 'lunr';
import isFunction from 'lodash/isFunction';
import { api } from '../services';
import { filterStore } from 'air-filter-mobx-store';

class GeofencesStore {
  @observable geofences = [];
  @observable loadedAt;
  @observable err;

  constructor(filterStore) {
    this.filterStore = filterStore;
    reaction(
      () => this.filterStore.globalFilterFunction,
      fn => {
        const geofences = this.geofences.map(geofence => {
          if (fn(geofence)) {
            return { ...geofence, hidden: false };
          } else {
            return { ...geofence, hidden: true };
          }
        });
        this.setGeofences(geofences);
      }
    );
  }

  buildIndex(geofences) {
    this.fullTextSearchIndex = lunr(function() {
      this.field('name');
      this.field('trigger');
      this.ref('id');

      geofences.forEach(geofence => {
        this.add(geofence);
      });
    });
    return geofences;
  }

  @action
  load() {
    return api('getGeofences').then(results => {
      let geofences = results.rows;
      this.setGeofences(geofences);
      this.setLoadedAt();

      setTimeout(() => {
        this.buildIndex(geofences);
      }, 500);
    })
      .catch(err => {
        this.err = err;
      })
  }

  @action setLoadedAt() {
    this.loadedAt = new Date().getTime();
  }

  @action
  setGeofences(geofences) {
    this.geofences = geofences;
  }

  @computed get filtered() {
    if (this.filterStore.globalFilterFunction) {
      return this.geofences.filter(this.filterStore.globalFilterFunction);
    } else {
      return this.geofences;
    }
  }

  filterLength = (filterType, attribute) => {
    if (isFunction(this.filterStore.predictionFns[`${filterType}.${attribute}`])) {
      return this[attribute].filter(this.filterStore.predictionFns[`${filterType}.${attribute}`]).length;
    }
    return this[attribute].length;
  };

  fullTextSearchFns = text => {
    let matches = this.fullTextSearchIndex.search(text);
    return {
      search: geofence => matches.findIndex(match => match.ref === geofence.id) > -1,
      sort: (geofence1, geofence2) => {
        let score1 = matches.find(match => match.ref === geofence1.id).score;
        let score2 = matches.find(match => match.ref === geofence2.id).score;
        return score2 - score1;
      }
    };
  };

  @action
  deleteGeofence(geofence) {
    return api('deleteGeofence', geofence.id).then(results => {
      if (results.success) {
        this.load();
      }
    });
  }
}

export default new GeofencesStore(filterStore);
  


// WEBPACK FOOTER //
// ./src/stores/geofencesStore.js